import config from '@/config';
import { LocationNameArraySchema } from '@/schemas/locationNameSchema';
import type { LocationNameType, FiltersType } from '@/types/schemaTypes';
import isSSR from '@/utils/isSSR';
import logger from '@/app/logger';
import { buildQuery } from '@/utils/url';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';
import type { Ref } from 'vue';

export const getLocationNamesQueryKey = (locationFilters: Ref<FiltersType>) => ['locationNames', locationFilters];
export const locationNamesQuery = async (locationFilters: FiltersType) => {
  const url = isSSR
    ? `${config.BACKEND.URL}/regions/lookup?${buildQuery(locationFilters)}`
    : `/api/regions/lookup?${buildQuery(locationFilters)}`;
  logger.info(`Fetching location names data: ${url}...`);
  return axios
    .get(url)
    .then((res) => {
      const length = res.data?.length ? res.data.length : 0;
      logger.info(`Location names: Got response items: ${length}`);
      return LocationNameArraySchema.parse(res.data);
    })
    .catch((err) => {
      logger.info('Location names: Got error:', err);
      return Promise.reject(err);
    });
};

export default function useLocationNamesData(locationFilters: Ref<FiltersType>, enabled: Ref<boolean>) {
  const query = useQuery<LocationNameType[]>({
    queryKey: getLocationNamesQueryKey(locationFilters),
    queryFn: () => locationNamesQuery(locationFilters.value),
    enabled,
  });

  return query;
}
